export default __webpack_public_path__ + "static/media/a.946aefb3c677af504ef06cbddac200a4.mp3";